import { PrispevokVestnikaPrilohaDownloadApi } from 'vestniky-frontend-ts-axios';
import { ClientResponse } from '../model/types/ClientResponse';
import { vestnikyPrefixPath } from './configuration/apiConfigurationConstants';
import apiConfiguration from './configuration/apiConfiguration';

const client = new PrispevokVestnikaPrilohaDownloadApi(apiConfiguration(vestnikyPrefixPath));

const downloadPriloha = async (
  prilohaUuid: string,
  options?: { headers?: object },
): Promise<ClientResponse<Blob>> => {
  const {
    data,
    status,
  } = await client.downloadPriloha(prilohaUuid, { ...options, responseType: 'blob' });
  return {
    data: data && new Blob([data]),
    responseCode: status,
  };
};

export default downloadPriloha;
